/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const Complexe = require('../types/Complexe')
const kernel = require('../kernel/kernel')
const CElementBase = require('./CElementBase')

module.exports = CValDyn

/**
 * Classe ancêtre de tous les objets représentant un objet numérique, calcul ou mesure.
 * @constructor
 * @extends CElementBase
 * @param {CListeObjets} listeProprietaire
 * @param {CImplementationProto} impProto : null ou pointeur sur la construction propriétaire
 * @param {Boolean} estElementFinal
 * @returns {undefined}
 */
function CValDyn (listeProprietaire, impProto, estElementFinal) {
  if (arguments.length !== 0) {
    if (arguments.length === 1) CElementBase.call(this, listeProprietaire);
    else CElementBase.call(this, listeProprietaire, impProto, estElementFinal);
    this.z1 = new Complexe();
  }
}
CValDyn.prototype = new CElementBase();
CValDyn.prototype.constructor = CValDyn;
CValDyn.prototype.superClass = "CElementBase";
CValDyn.prototype.className = "CValDyn";

/** inheritDoc */
CValDyn.prototype.getNature = function() {
  return NatObj.NAucunObjet;
};
// Méthode à redéfinir pour les descendants renvoyant la valeur. Ne sert pas ici
/**
 * Fonction renvoyant la valeur du calcul (réelle).
 * Doit être redéfini pour les descendants
 * @returns {number}
 */
CValDyn.prototype.rendValeur = function() {
  return 0;
};
/**
 * Fonction renvoyant la valeur du calcul complexe dans zRes.
 * Doit être redéfini pour les descendants
 * @param {Complexe} zRes

 */
CValDyn.prototype.rendValeurComplexe = function(zRes) {
  zRes.x = this.rendValeur();
  zRes.y = 0;
};
/**
 * Renvoie la valeur du calcul réel sous forme d'une chaîne
 * @param {int} nbDecimales : le nombre de décimales souhaité
 * @returns {string}
 */
CValDyn.prototype.rendChaineValeur = function(nbDecimales) {
  return kernel.chaineNombre(this.rendValeur(), nbDecimales);
};
/**
 * Renvoie la valeur du calcul complexe sous forme d'une chaîne
 * @param {int} nbDecimales
 * @returns {string}
 */
CValDyn.prototype.rendChaineValeurComplexe = function(nbDecimales) {
  this.rendValeurComplexe(this.z1);
  return this.z1.chaineValeurComplexe(nbDecimales);
};
/**
 * Renvoie la valeur du calcul réel sous forme d'une chaîne
 * @param {int} nbDecimales
 * @returns {string}
 */
CValDyn.prototype.rendChaineValeurPourCommentaire = function(nbDecimales)
{
  return this.rendChaineValeur(nbDecimales);
};
/**
 * Renvoie true si ch est égale au nom de a valeur
 * @param {string} ch
 * @returns {boolean}
 */
CValDyn.prototype.chaineEgaleANom = function(ch) {
  return (this.getNom() === ch);
};
// Ne sera redéfini que pour les calculs et les variables
/**
 * Renvoie le nom de la valeur
 * Ne sera redéfini que pour les calculs et les variables
 * @returns {string}
 */
CValDyn.prototype.getNom = function() {
  return "";
};
/**
 * Renvoie true si ch commence par le nom de la valeur
 * @param {Sstring} ch
 * @param {Object} longueurNom : Contient dans x au retour la longueur du nom
 * si la chaine commence bien par ch
 * @returns {boolean}
 */
CValDyn.prototype.chaineCommenceParNom = function(ch, longueurNom){
  var chaineNom = this.getNom();
  longueurNom.x = chaineNom.length;
  var longueurChaine2 = ch.length;
  if (longueurChaine2 < longueurNom.x) return false;
  else return chaineNom === ch.substring(0, longueurNom.x);
};
/**
 * Renvoie true si l'objet est une fonction ou une suite
 * @returns {boolean}
 */
CValDyn.prototype.estFonctionOuSuite = function() {
  return false;
};
/**
 * Renvoie true si le résultat de la valeur est constant
 * A redéfinir pour les descendants
 * @returns {boolean}
 */
CValDyn.prototype.estConstant = function() {
  return false;
};
/**
 * Renvoie le membre de gauche de l'opérateur dans le cas d'une calcul avec opération
 * @returns {CCb}
 */
CValDyn.prototype.membreGauche = function() {
  return null;
};
/**
 * Renvoie le membre de droite de l'opérateur dans le cas d'une calcul avec opération
 * @returns {CCb}
 */
CValDyn.prototype.membreDroit = function() {
  return null;
};
/**
 * Renvoie true si le nom de la valeur commence par st
 * @param {String} st
 * @returns {Boolean}
 */
CValDyn.prototype.nomCommencePar = function(st){
  return this.getNom().indexOf(st)===0;
};




// WEBPACK FOOTER //
// ./src/objets/CValDyn.js